import { formatDate } from '@/support/String';
import { cloneDeep } from 'lodash';
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';

@Component
export default class DateFilter extends Vue implements FilterInterface {

  // #region @PropSyncs

  @PropSync('filter')
  protected internalFilter!: string;

  // #endregion

  // #region @Props

  @Prop({ default: '' })
  protected filterDefault!: string;

  @Prop({ default: 'name' })
  protected filterStorageKey!: string;

  @Prop({ default: 'filters' })
  protected filtersStorageKey!: string;

  @Prop({ default: 'Datum' })
  protected label!: string;

  @Prop({ default: 'dd-mm-jjjj' })
  protected placeholder!: string;

  // #endregion

  // #region Props

  protected finalReturnDatePicker = false;

  // #endregion

  // #region Lifecycle hooks / Init

  protected mounted(): void {
    this.initialize();
  }

  protected async initialize(): Promise<void> {
    this.initializeFilter();

    this.$emit('filter-loaded');
  }

  protected initializeFilter(): void {
    const filters = localStorage.getItem(`${this.$route.name}_${this.filtersStorageKey}_${this.filterStorageKey}`);

    this.internalFilterGetterSetter = filters && filters !== 'undefined'
      ? filters
      : this.filterDefault;
  }

  // #endregion

  // #region Handlers

  protected onResetFilter(): void {
    this.resetFilter();
  }

  // #endregion

  //#region Helpers

  protected formattedDate(date: string) {
    return date ? formatDate(date) : this.placeholder;
  }

  // PUBLIC
  public resetFilter(): void {
    this.internalFilterGetterSetter = cloneDeep(this.filterDefault);
  }

  //#endregion

  //#region Getters & Setters

  protected get internalFilterGetterSetter(): string {
    return this.internalFilter;
  }

  protected set internalFilterGetterSetter(value: string) {
    localStorage.setItem(`${this.$route.name}_${this.filtersStorageKey}_${this.filterStorageKey}`, `${value}`);
    this.internalFilter = value;
  }

  //#endregion
}
